<script>
import {forEach, keys, reduce} from 'lodash'; 
import transitionFade from '../transition/fade';
const initOriginal = () => ({
    rootStyle: {},
    scrollTop: 0,
    scrollLeft: 0
});
export default {
    props: {
        zIndex: {
            type: [String, Number],
            default: 99
        },
        status: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            body: document.body,
            root: document.documentElement,
            count: 0,
            original: initOriginal(),
            afterRootStyle: {
                position: 'fixed',
                height: '100%',
                overflow: 'hidden',
                left: 0,
                right: 0
            }
        }
    },
    methods: {
        show() {
            this.count++;
        },
        hide() {
            if (this.count > 0) {
                this.count--;
            }
        },
        getRootStyle() {
            return reduce(keys(this.afterRootStyle), (obj, key) => {
                obj[key] = this.root.style[key];
                return obj;
            }, {})
        },
        setRootStyle(style) {
            forEach(style, (value, key) => {
                this.root.style[key] = value;
            });
        },
        showHandle() {
            this.original.rootStyle = this.getRootStyle();
            this.original.scrollTop = this.root.scrollTop || this.body.scrollTop;
            this.original.scrollLeft = this.root.scrollLeft || this.body.scrollLeft;
            this.setRootStyle({...this.afterRootStyle, top: -this.original.scrollTop + 'px', left: (this.original.scrollleft || 0) + 'px'});
            // TODO 凑合一下没时间了
            this.body.style.overflow = 'hidden';
        },
        hideHandle() {
            this.setRootStyle({...this.original.rootStyle, top: '', left: '', right: ''});
            // TODO 凑合一下没时间了
            this.body.style.overflow = '';
            this.root.scrollTop = this.body.scrollTop = this.original.scrollTop;
            this.root.scrollLeft = this.body.scrollLeft = this.original.scrollLeft;
            // this.root.scrollTo(
            //     this.original.scrollLeft,
            //     this.original.scrollTop
            // );
            this.original = initOriginal();
        },
        clickHandler() {
            this.$emit('click', this.status);
        }
    },
    watch: {
        count(newVal, oldVal) {
            if (newVal > 0 && oldVal > 0) {
                return;
            }
            if (this.count) {
                this.showHandle();
            } else {
                this.hideHandle();
                this.status = false;
                this.$emit('change', this.status);
            }
        },
        status: {
            immediate: true,
            handler: function () {
                if (this.status) {
                    this.show();
                } else {
                    this.hide();
                }
            }
        }
    },
    components: {
        transitionFade
    }
};
</script>
<template>
    <transition-fade>
        <div 
            v-if="count"
            class="shadow-container"
            :style="{
                zIndex: zIndex
            }"
            @click="clickHandler"
        >
            <slot></slot>
        </div>
    </transition-fade>
</template>
<style lang="stylus" scoped>
.shadow-container
    position fixed;
    top 0
    left 0
    height 100%
    width 100%
    background rgba(0, 0, 0, .6)
</style>